import * as React from 'react';

import {AiHomepageHeader} from 'shells/ai-homepage/text/ai-homepage-header';
import {Stack} from 'shells/layout/stack/stack';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';

import {AiTabs} from '../shared/components/ai-tabs';

export type TabProps = {
    selectedTab: AiFeaturePeriod;
    setSelectedTab: (tab: AiFeaturePeriod) => void;
};
type Props = {
    tabProps?: TabProps;
};

export function UsageHeader(props: Props) {
    const tabs = React.useMemo(
        () => [
            {id: 'WEEK', label: 'This week'},
            {id: 'MONTH', label: 'This month'},
            {id: 'YEAR', label: 'This year'},
        ],
        []
    );

    return (
        <Stack
            isHorizontal={true}
            alignItems='center'
            justifyContent='space-between'
            isFullWidth={true}
        >
            <AiHomepageHeader text='AI usage' />
            {props.tabProps && (
                <AiTabs
                    tabs={{
                        options: tabs,
                        selectedTab: props.tabProps.selectedTab,
                        // @ts-expect-error
                        onChangeTab: props.tabProps.setSelectedTab,
                    }}
                />
            )}
        </Stack>
    );
}
